define('formkit/view/form/section/section.header.item.answer.view',['require','exports','module','uikit/uikit','../../../templates','../../../behavior/call.registered.view.method.on.press.behavior','../../../behavior/register.view.behavior','../../../behavior/bind.option.to.active.section.change.behavior'],function(require, exports, module) {
  var UIKit                                   = require('uikit/uikit');
  var Templates                               = require('../../../templates');
  var CallRegisteredViewMethodOnPressBehavior = require('../../../behavior/call.registered.view.method.on.press.behavior');
  var RegisterViewBehavior                    = require('../../../behavior/register.view.behavior');
  var BindOptionToActiveSectionChangeBehavior = require('../../../behavior/bind.option.to.active.section.change.behavior');


  var SectionHeaderItemAnswerView = UIKit.ItemView.extend({
    className: 'ui segment padded blue sectionHeader',

    template: Templates.App['section.header.answer'],

    internalViewOptions: {
      headerTextView: function() {
        return {
          type: UIKit.Header,
          model: this.model,
          tagName: 'h3',
          bindings: {
            text: 'text'
          }
        }
      }
    },

    behaviors: {
      BindOptionToActiveSectionChangeBehavior: {
        behaviorClass: BindOptionToActiveSectionChangeBehavior,
        optionName: 'visible',
        valueWhenActive: true,
        valueWhenInactive: false
      }
    }
  });

  module.exports = SectionHeaderItemAnswerView;
});

